import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, IconButton, Snackbar, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../assets/images/favicon.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useAlert } from "../../context/AlertContext";

export default function SubscriptionAlert() {
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const checkSubscription = () => {
      const isSubscription = String(localStorage.getItem("is_subscription"));
      const isExpired = String(localStorage.getItem("isExpired"));
      const isTrialExpired = String(localStorage.getItem("isTrialExpired"));
      const role = localStorage.getItem("role");

      const shouldShowRenewAlert =
        role === "Admin" &&
        (isExpired === "true" || isTrialExpired === "true");

      const shouldShowSubscriptionAlert =
        role === "Admin" &&
        isSubscription === "false";

      // Contextual message based on the situation (most specific first).
      let alertMessage = "";
      if (isExpired === "true") {
        alertMessage =
          "Your subscription has expired. Renew your plan and start managing your business smart.";
      } else if (isTrialExpired === "true") {
        alertMessage =
          "Your free trial has ended. Purchase a plan to continue managing your business.";
      } else if (isSubscription === "false") {
        alertMessage = "Purchase a plan and start managing your business.";
      }

      if (
        (shouldShowRenewAlert || shouldShowSubscriptionAlert) &&
        alertMessage &&
        location.pathname !== "/planManagement" &&
        location.pathname !== "/dashboard/profile"
      ) {
        setMessage(alertMessage);
        setOpen(true);
      } else {
        setOpen(false);
      }
    };

    checkSubscription();

    window.addEventListener("subscription_updated", checkSubscription);

    return () => {
      window.removeEventListener(
        "subscription_updated",
        checkSubscription
      );
    };
  }, [location.pathname]);

  const handleManagePlan = () => {
    const billingInfo = String(localStorage.getItem("billing_info"));
    if (billingInfo === "true") {
      navigate("/planManagement");
    } else {
      navigate("/dashboard/profile");
      showAlert("Please complete your Billing Information first", "info");
    }
    // Optional: close the alert after clicking
    // setOpen(false);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={open}
    >
      <Box sx={{
        backgroundColor: "#FBD6D6",
        minWidth: "35em",
        width: "fit-content",
        display: "flex",
        flexDirection: "row",
        borderRadius: "10px",
        padding: "12px 16px",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        gap: 3
      }}>
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <Avatar src={logo} sx={{ width: 40, height: 40 }} />
          <Box sx={{ ml: 2 }}>
            <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#d32f2f", lineHeight: 1.2, mb: 0.5 }}>Alert</Typography>
            <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}>{message}</Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleManagePlan}
            sx={{
              borderColor: "#2e7d32",
              color: "#2e7d32",
              textTransform: "none",
              fontWeight: "600",
              whiteSpace: "nowrap",
              fontSize: "13px",
              padding: "4px 12px",
              "&:hover": {
                borderColor: "#1b5e20",
                backgroundColor: "rgba(46, 125, 50, 0.04)"
              }
            }}
          >
            Manage Plan
          </Button>
          <IconButton
            size="small"
            onClick={() => setOpen(false)}
            sx={{ color: "#d32f2f", padding: "4px" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Snackbar>
  );
}
